/* implemented: snippets/product-page-get-main.liquid */

document.addEventListener("DOMContentLoaded", function () {

  /* FAQ's */
  function initFAQ(){
    const faqs = document.querySelectorAll(".faq-item")

    if(!faqs){
      console.log("FAQ can not be found")
      return
    }

    faqs.forEach(faq => {
      faq.addEventListener('click', (e) =>{
        const parent = e.target.parentElement.querySelector(".faq-content")
        parent?.classList?.toggle("is-open")
      })
    })

  }
  initFAQ()

  /*
    Load drawer contet based on page data
    page: /pages/cane-sizing-product-drawer
  */
  const asyncDrawers = document.querySelectorAll(".async-drawer")

  function handleAsyncDrawer(e){
    e.preventDefault();
    fetch('/pages/cane-sizing-product-drawer')
      .then(response => response.text())
      .then(data => {
        document?.querySelector(".size-guide-loader__container")?.classList?.add("hidde")
        document.getElementById('size-guide-drawer').innerHTML = data;

        var accItem = document.getElementsByClassName('accordionItem');
        var accHD = document.getElementsByClassName('accordionItemHeading');
        for (i = 0; i < accHD.length; i++) {
            accHD[i].addEventListener('click', toggleItem, false);
        }
        function toggleItem() {
            var itemClass = this.parentNode.className;
            for (i = 0; i < accItem.length; i++) {
                accItem[i].className = 'accordionItem close';
            }
            if (itemClass == 'accordionItem close') {
                this.parentNode.className = 'accordionItem open';
            }
        }
      });
  }

  function initAsyncDrawers(){
    if(asyncDrawers.length === 0){
      return console.log("Can't found async drawer togglers")
    }
    //console.log("async drawers", asyncDrawers)

    asyncDrawers.forEach(drawer => drawer.addEventListener("click", handleAsyncDrawer))
  }

  initAsyncDrawers()
});
